import * as React from "react";
import { cn } from "@/lib/utils";

interface FormControlProps extends React.HTMLAttributes<HTMLDivElement> {
  invalid?: boolean;
}

const FormControl = React.forwardRef<HTMLDivElement, FormControlProps>(
  ({ className, invalid, ...props }, ref) => {
    return <div ref={ref} className={cn("space-y-2", className)} {...props} />;
  },
);
FormControl.displayName = "FormControl";

interface FormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const FormLabel = React.forwardRef<HTMLLabelElement, FormLabelProps>(
  ({ className, required, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
          className,
        )}
        {...props}
      >
        {children}
        {required && <span className="text-destructive ml-1">*</span>}
      </label>
    );
  },
);
FormLabel.displayName = "FormLabel";

export { FormControl, FormLabel };
